import {Component, Input, OnInit} from '@angular/core';
import {LocalDataSource} from 'ng2-smart-table';
import {CovidService} from '../../../../services/covid.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import * as moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {FilesService} from '../../../../services/files.service';
import { StationService } from '../../../../services/stations.service';

@Component({
  selector: 'ngx-positive-tests',
  templateUrl: './positive-tests.component.html',
  styleUrls: ['./positive-tests.component.scss'],
})
export class PositiveTestsComponent implements OnInit {
  @Input() stationId: string;
  source: LocalDataSource;
  loading: boolean = false;
  token: any = '';
  countData = 0;
  settings = {
    actions: false,
    pager: {
      perPage: 10,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      dateSymptoms: {
        title: 'Fecha inicio síntomas',
        filter: true,
      },
      dateDetection: {
        title: 'Fecha detección',
        filter: true,
      },
      role: {
        title: 'Puesto',
        filter: true,
      },
      quarantine: {
        title: 'Días en cuarentena',
        filter: true,
      },
    },
  };

  constructor(
    private covidService: CovidService,
    private fileService: FilesService,
    private stationService: StationService,
  ) {
    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  async ngOnInit() {
    this.init();
  }

  init() {
    this.getTestsPositiveByStationId();
  }

  async getTestsPositiveByStationId() {
    this.loading = true;
    const [err, response]: any = await this.covidService.getTestsPositiveByStationId(this.stationId);
    this.loading = false;
    if (err) if (err) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    this.source = new LocalDataSource(await this.formattedDataForTable(response.data.tests));
  }

  async formattedDataForTable(tests: any) {
    const dataFormatted = [];
    for await (const test of tests) {
      dataFormatted.push({
        name: test.employee.name,
        dateSymptoms: (test.dateSymptoms) ? moment(test.dateSymptoms).format('ll') : 'NA',
        dateDetection: moment(test.dateDetection).format('ll'),
        role: test.employee.role,
        gender: test.employee.gender || '',
        age: test.employee.age || '',
        contagionType: test.contagionType || '',
        quarantine: await this.calculateDaysQuarantine(test.dateDetection),
      });
    }
    this.countData = dataFormatted.length;
    return dataFormatted;
  }

  async calculateDaysQuarantine(date: string) {
    const diffDays = moment().diff(date, 'd');
    return (Math.sign(diffDays)) !== -1 ? diffDays : 0;
  }

  generateUrl() {
    return `${environment.baseEndpoint}/covid/download/${this.stationId}/employee/tracking`;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadFile(name) {
    this.loading = true;
    await this.fileService.downloadFile(this.generateUrl(), name.toLowerCase().replace(' ', '_'));
    this.loading = false;
  }

}
